import { render, staticRenderFns } from "./TabWithdrawApprove.vue?vue&type=template&id=c9b595f0&scoped=true&"
import script from "./TabWithdrawApprove.vue?vue&type=script&lang=js&"
export * from "./TabWithdrawApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b595f0",
  null
  
)

export default component.exports